import React, { useState } from "react";
import "./BlogBox.css";
import moment from "jalali-moment";
import { BsCheckLg, BsPlusSquare } from "react-icons/bs";
import { RiUploadCloudLine } from "react-icons/ri";
import { BiGlasses, BiTrash } from "react-icons/bi";
import { HiOutlinePencilAlt } from "react-icons/hi";

function BlogBox(props) {
    const { building } = props;
    let StateClass = "BuildingBoxItemStateNew";
    // if (building.state === "جدید") {
    //     StateClass = "BuildingBoxItemStateNew";
    // }
    // if (building.state === "در حال ارزیابی") {
    //     StateClass = "BuildingBoxItemStateInProgress";
    // }
    // if (building.state === "ارجاع شده") {
    //     StateClass = "BuildingBoxItemStateReferred";
    // }
    // if (building.state === "تکمیل شده") {
    //     StateClass = "BuildingBoxItemStateCompleted";
    // }

    const [tick, setTick] = useState(false);
    return (
        <div className="BuildingBox" style={{ display: "flex" }}>
            <div className="BuildingBoxItem1" style={{ flexGrow: 1 }}>
                <div className="SCheckboxTick BuildingBoxItem1Tick" onClick={() => setTick(!tick)}>
                    {tick ? <BsCheckLg /> : <></>}
                </div>
                <span className="BuildingBoxItemTitle BuildingBoxItemTitle1">{props.index + 1}</span>
            </div>

            <div className="BuildingBoxItem2" style={{ flexGrow: 4, maxWidth: "40%", minWidth: "40%", padding: "12px" }}>
                <span className="BuildingBoxItemTitle">{props.data.title}</span>
            </div>
            <div className="BuildingBoxItem3" style={{ flexGrow: 2 }}>
                <span className="BuildingBoxItemTitle"></span>
            </div>
            <div className="BuildingBoxItem4" style={{ flexGrow: 2 }}>
                <span className="BuildingBoxItemTitle">{moment(props.data.updatedAt).locale("fa").format("YYYY/MM/DD")}</span>
            </div>
            <div className="BuildingBoxItem8" style={{ flexGrow: 2 }}>
                <div className="BuildingBoxItem8Icons">
                    {/* <div className="BuildingBoxItem8Icon">
                        <RiUploadCloudLine />
                    </div>
                    <div className="BuildingBoxItem8Icon">
                        <BiGlasses />
                    </div> */}
                    <div className="BuildingBoxItem8Icon">
                        <HiOutlinePencilAlt />
                    </div>
                    <div className="BuildingBoxItem8Icon BuildingBoxItem8IconLast">
                        <BiTrash />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default BlogBox;
